import { store } from '../../../store/store';
import actions from '../actions';
export const show = (type, dialogProps) => {
    store.dispatch(actions.show(type, dialogProps));
};
